import styled, { css } from "styled-components"

import Pc from "~/components/atoms/Pc"
import Sp from "~/components/atoms/Sp"
import Typography from "~/components/atoms/Typography"
import Carousel from "~/components/molecules/Carousel"
import { Color, IsMobile, IsPC, SpacingSize } from "~/consts/style-mixins"
import { Company } from "~/entities/Company"

interface Props {
  company: Company
  className?: string
}

const CompanyHead = ({ company, className }: Props) => {
  return (
    <div className={className}>
      <StyledCarouselWrapper>
        <Carousel>
          {company.companyImages &&
            company.companyImages.map((image, index) => {
              return <StyledCarouselImage key={index} src={image} alt={`${company.name}のカバー画像`} />
            })}
        </Carousel>
        <StyledIconImage src={company.logoImgUrl} alt={`${company.name}のロゴ画像`} />
      </StyledCarouselWrapper>
      <Pc>
        <StyledTypographyTitle type="SubHero">{company.name}</StyledTypographyTitle>
      </Pc>
      <Sp>
        <StyledTypographyTitle type="SubHero">{company.name}</StyledTypographyTitle>
      </Sp>
      {/* <StyledTypographySub type="Description">{company.overview}</StyledTypographySub> */}
    </div>
  )
}

const StyledCarouselWrapper = styled.div`
  margin-bottom: ${SpacingSize["2XL"]}px;
  position: relative;
  ${IsMobile(css`
    margin-right: -16px;
    margin-left: -16px;
  `)}
`

const StyledCarouselImage = styled.img`
  height: calc(100vw * 0.35);
  object-fit: cover;
  ${IsPC(css`
    height: 235px;
    border-radius: 8px;
  `)}
`

const StyledIconImage = styled.img`
  width: 96px;
  height: 96px;
  background: white;
  border: 1px solid ${Color.BorderGray};
  border-radius: 50%;
  position: absolute;
  bottom: -48px;
  right: 16px;
  object-fit: cover;
`

const StyledTypographyTitle = styled(Typography)`
  color: ${Color.Black};
  width: calc(100% - 112px);
  ${IsMobile(css`
    width: calc(100% - 96px);
  `)}
`

// const StyledTypographySub = styled(Typography)`
//   color: ${Color.LightGray};
//   line-height: 160%;
//   margin-top: 4px;
// `
export default CompanyHead
